import axiosClient from "../common/axios/axiosConfig";

const cancelSchedule = async (idAgendamento: string) => {
	return axiosClient
		.post("/cancelar-agendamento", {
			idAgendamento,
		})
		.then(response => {
			return response.data;
		})
		.catch((error) => {
			return {
				success: false,
				status: error.response?.status,
				message: error.response?.data?.message,
			};
		});
};

export default cancelSchedule;
